import { Layout as AntdLayout, type LayoutProps as AntdLayoutProps } from 'antd'

type HeaderProps = AntdLayoutProps

export function Header(props: HeaderProps) {
  return <AntdLayout.Header {...props} />
}
